module.exports = [{
      plugin: require('../.yarn/unplugged/gatsby-virtual-969caf9d97/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
